import React from 'react'

import EditorHtml from './EditorHtml'
import HomePageTrustpilot from './HomePageTrustpilot'

const PageHeader = ({ title, subtitle, children, childrenFirst = false, notice = null }) => {
  const subtitleClassName =
    "m-0 max-w-[558px] font-['Inter'] text-[16px] font-normal leading-[24px] text-[#6d6d6d] md:text-[20px] md:leading-[32px]"

  return (
    <section
      style={{
        position: 'relative',
        width: '100%',
        overflow: 'hidden',
        backgroundColor: '#f7f8f3',
        backgroundImage: [
          'radial-gradient(ellipse 42% 30% at 50% 18%, rgba(143,192,69,0.18) 0%, rgba(143,192,69,0.10) 34%, rgba(247,248,243,0) 78%)',
          'linear-gradient(180deg, rgba(255,255,255,0.18) 0%, rgba(247,248,243,0) 42%)',
        ].join(', '),
      }}
    >
      <div
        className='relative flex w-full flex-col items-center justify-center gap-[24px] px-4 pb-[12px] pt-[72px] md:gap-[56px] md:pb-[32px] md:pt-[104px]'
        style={{
          backgroundImage:
            'url("data:image/svg+xml,%3Csvg width=\'75.6\' height=\'75.6\' viewBox=\'0 0 75.6 75.6\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Crect width=\'3.6\' height=\'3.6\' fill=\'%238fc045\' fill-opacity=\'0.22\'/%3E%3C/svg%3E")',
          backgroundPosition: 'center top',
          backgroundRepeat: 'repeat',
          zIndex: 1,
        }}
      >
        <div className='z-10 flex w-full max-w-[396px] flex-col items-center gap-[24px] text-center md:max-w-[1088px] md:gap-[32px]'>
          <div className='flex flex-col items-center gap-[16px] md:gap-[24px]'>
            <h1 className="m-0 max-w-[960px] font-['Inter'] text-[40px] font-bold leading-[48px] tracking-[0] text-[#262f39] md:text-[72px] md:leading-[79.2px] md:tracking-[-1.8px]">
              {title}
            </h1>

            {typeof subtitle === 'string' ? (
              <EditorHtml compact content={subtitle} className={subtitleClassName} />
            ) : subtitle ? (
              <div className={subtitleClassName}>
                {subtitle}
              </div>
            ) : null}
          </div>

          {notice ? <div className='w-full'>{notice}</div> : null}

          {childrenFirst && children ? <div className='w-full'>{children}</div> : null}

          <HomePageTrustpilot />

          {!childrenFirst && children ? <div className='w-full'>{children}</div> : null}
        </div>
      </div>
    </section>
  )
}

export default PageHeader